import React from "react";
import { useTranslation, Trans } from "react-i18next";

import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";
import { APPINSIGHTS_STRINGS } from "../../constants/appInsightsStrings";
import { trackEvent } from "../../utils/appInsights";
import XTPProduct from "../../assets/XTP-product.png";
import dollarIcon from "../../assets/dollar-icon.svg";
import speedometerIcon from "../../assets/speedometer-icon.svg";
import calendarIcon from "../../assets/calendar-icon.svg";
import decreaseIcon from "../../assets/decrease-icon.svg";
import increaseIcon from "../../assets/increase-icon.svg";
import { integraTecXTPStrings } from "../../constants/integraTecXTPStrings";
import { XTPUrlStrings } from "../../constants/urlStrings";
import { USER_INFO } from "../../constants/globalStrings";

import "./XTPBenefits.scss";

const XTPBenefits = ({ xtpSavings, forecastDays }) => {
  const {
    xtp_cost_savings,
    xtp_cost_savings_percentage,
    xtp_water_benefit,
    xtp_water_benefit_percentage,
  } = xtpSavings;
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const productURL = (
    XTPUrlStrings[language] || XTPUrlStrings[USER_INFO.cultureName]
  ).moreInfoLink;

  const handleLearnMoreClick = () => {
    trackEvent(APPINSIGHTS_STRINGS.XTP_LEARN_MORE_CLICKED, {
      language: language,
      url: productURL
    });
  };

  return (
    <div className="tealBorder xtp-wrapper flex-between-center margin-top-10">
      <img src={XTPProduct} alt="XTP Product" className="xtp-product-image" />
      <div className="flex-ai-center benefits-wrapper">
        <div className="benefits-text">
          <Trans
            i18nKey="integraTecXTP.benefitsText"
            values={{ productName: integraTecXTPStrings.productName }}
            components={{
              strong: <strong className="highlight" />,
            }}
          />
        </div>
        <div className="xtp-benefits">
          <img src={dollarIcon} alt="Dollar Icon" className="icon" />
          <div>
            <div className="xtp-label">{t("integraTecXTP.OPEXCost")}</div>
            <div className="xtp-value">$ {xtp_cost_savings.toFixed(2)}</div>
            <div className="xtp-percentage">
              {xtp_cost_savings_percentage.toFixed(2)} %
              <img
                src={decreaseIcon}
                alt="decrease icon"
                className="measure-icon"
              />
            </div>
          </div>
        </div>
        <div className="xtp-benefits">
          <img src={speedometerIcon} alt="Speedometer Icon" className="icon" />
          <div>
            <div className="xtp-label">{t("integraTecXTP.productivity")}</div>
            <div className="xtp-value">$ {xtp_water_benefit.toFixed(2)}</div>
            <div className="xtp-percentage">
              {xtp_water_benefit_percentage.toFixed(2)} %
              <img
                src={increaseIcon}
                alt="increase icon"
                className="measure-icon"
              />
            </div>
          </div>
        </div>
        <div className="xtp-benefits">
          <img src={calendarIcon} alt="Forecast Period" className="icon" />
          <div>
            <div className="xtp-label">{t("integraTecXTP.forecastPeriod")}</div>
            <div className="xtp-value">
              {forecastDays} {forecastDays > 1 ? "days" : "day"}
            </div>
          </div>
        </div>
      </div>
      <div className="more-details">
        <a
          href={productURL}
          target="_blank"
          rel="noopener noreferrer"
          className="learn-more-link"
          onClick={handleLearnMoreClick}
        >
          {t("integraTecXTP.learnMore")}
        </a>{" "}
        <span>{t("integraTecXTP.aboutTheModule")}</span>
      </div>
      <PopoverText
        descriptor={<img src={InfoIconGreen} alt="info icon" />}
        descriptionText={t("integraTecXTP.benefitsTooltipText", {
          productName: integraTecXTPStrings.productName,
        })}
      />
    </div>
  );
};

export default XTPBenefits;
